module.exports = __webpack_public_path__ + "img/client13.fadbe138.png";